export default "__VITE_ASSET__DXo8C64t__"